import React, { useState, useEffect } from "react";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import MenuList from "@material-ui/core/MenuList";
import { appService } from "../../../services/app.service";
import { commonService } from "../../../services/common.service";
import "../../app/base-style.css";
import "../layout.css";
import { useHistory } from "react-router-dom";
import { routePaths } from "../../config/route-paths";
import { Grid, Tooltip } from "@material-ui/core";
import { ProfileAccountDropdown } from "../header/profile-account-dropdown/profile-account-dropdown";
import { store } from "../../../helpers/store";
import { useDispatch, useSelector } from "react-redux";
import { updateSelectedVal } from "../../e_layout/e_header/e_profile_dropdown/model/profile-action";
import PersonIcon from "@material-ui/icons/Person";
export default function UserProfileMenu(props) {
  let labels,
    sideLabels = {};
  if (appService.getLabels()) {
    labels = appService.getLabels().getLabels.HEADER;
    sideLabels = appService.getLabels().getLabels.SIDEBAR;
  }
  let notification = useSelector((store) => store?.notificationDot?.data);

  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const [managePreference_Widget, setManagePreference_Widget] = useState(false);
  const prevOpen = React.useRef(open);
  const anchorRef = React.useRef(null);
  const widgetLookup = useSelector(
    (state) => state?.parametersWidgets?.WidgetLookUp
  );
  useEffect(() => {
    if (widgetLookup) {
      setManagePreference_Widget(
        widgetLookup.filter(
          (item) => item.widgetCode === "SIDEBAR.MANAGE_PREFERENCE"
        )
      );
    }
  }, [widgetLookup]);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.push(routePaths.PROFILE);
    store.dispatch(updateSelectedVal(event.target.value));
    setOpen(false);
  };

  const handleMClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.push(routePaths.MANAGE_PREFERENCE);
    store.dispatch(updateSelectedVal(event.target.value));
    setOpen(false);
  };

  const handleCloseAway = () => {
    setOpen(false);
  };

  const handleClick = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    history.push(routePaths.SELF_HELP);
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  const padClass = { padding: "5px 0px 0px 10px" };
  const logout = (event) => {
    setOpen(false);
    let unreadMeter = localStorage.getItem("unreadMeter");
    let unreadBill = localStorage.getItem("unreadBill");
    let unreadAnnouncement = localStorage.getItem("unreadAnnouncement");
    unreadMeter = JSON.parse(unreadMeter);
    unreadBill = JSON.parse(unreadBill);
    unreadAnnouncement = JSON.parse(unreadAnnouncement);

    if (
      unreadBill?.length > 0 ||
      unreadMeter?.length > 0 ||
      unreadAnnouncement?.length > 0 ||
      notification?.Meter === true ||
      notification?.Bill === true ||
      notification?.Outage === true ||
      notification?.Announcements === true
    ) {
      let ok = window.confirm(labels?.NOTIFICATION_LOGOUT_WARNING);
      if(ok === true){
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
          return;
        }
        commonService.logoutUser();
      }
      window.addEventListener("beforeunload", (event) => {
        event.returnValue = labels.NOTIFICATION_LOGOUT_WARNING
      });
    }else{
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    commonService.logoutUser();
  }
  };


  const [isMultipleAccounts, setIsMultipleAccounts] = useState(false);
  store.subscribe((stateChanged) => {
    if (store.getState().accountInformation.accountDetails) {
      if (store.getState().accountInformation.accountDetails.length == 1) {
        setIsMultipleAccounts(true);
      }
    }
  });

  return (
    <Grid container>
      <Grid item align="right">
        {<ProfileAccountDropdown props={props} />}
      </Grid>
      <Grid item style={padClass}>
        <div className="cursor-pointer">
          <Avatar
            alt="profile photo"
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            imgProps={{
              height: "100%",
              width: "100%",
              margin: "10%",
            }}
          >
            <PersonIcon />
          </Avatar>

          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleCloseAway}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem
                        className="profile-menu-item"
                        id="profile-menu-option-details"
                        value={0}
                        onClick={handleClose}
                      >
                        {labels.PROFILE_MENU_OPTION_PROFILE_DETAILS}
                      </MenuItem>
                      {managePreference_Widget && (
                        <Tooltip title="View and manage your service preferences.">
                          <MenuItem
                            className="profile-menu-item"
                            id="profile-menu-option-manage-preferences"
                            value={1}
                            onClick={handleMClose}
                          >
                            {sideLabels?.SIDEBAR_MANAGE_PREFERENCE}
                          </MenuItem>
                        </Tooltip>
                      )}
                      <MenuItem
                        className="profile-menu-item"
                        id="profile-menu-option-password"
                        value={2}
                        onClick={handleClose}
                      >
                        {labels.PROFILE_MENU_OPTION_LINKED_ACCOUNTS}
                      </MenuItem>
                      <MenuItem
                        className="profile-menu-item"
                        id="profile-menu-option-preferences"
                        onClick={handleClick}
                      >
                        {labels.PROFILE_MENU_OPTION_GET_HELP}
                      </MenuItem>
                      <MenuItem
                        className="profile-menu-item"
                        id="profile-menu-option-logout"
                        onClick={logout}
                      >
                        {labels.PROFILE_MENU_OPTION_LOGOUT}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Grid>
    </Grid>
  );
}
